import { createSelector } from 'reselect';
import { getInitialState } from './reducer';
var selectSignupDomain = function (signup) {
    return (signup && signup.signup) || getInitialState();
};
var selectSignupDevPlanDomain = function (signup) {
    return ((signup && signup.signup) || getInitialState()).devPlanId;
};
var selectSignupDevPlansDomain = function (signup) {
    return ((signup && signup.signup) || getInitialState()).devPlans;
};
var selectSignupCampaignDomain = function (signup) {
    return ((signup && signup.signup) || getInitialState()).campaign;
};
export var selectSignup = createSelector(selectSignupDomain, function (signup) { return signup; });
export var selectSignupDevPlanDataLayer = createSelector(selectSignupDevPlanDomain, selectSignupDevPlansDomain, selectSignupCampaignDomain, function (devPlanId, devPlans, campaign) {
    if (devPlanId === void 0) { devPlanId = ''; }
    if (campaign === void 0) { campaign = 'default'; }
    var id = devPlanId;
    var devPlan = devPlans.find(function (d) { return d.id === id; }) || {
        final_price: { usd: { amount: 0, currency: 'usd' } },
    };
    var _a = (devPlan.final_price[devPlan.currency] || {
        amount: 0,
        currency: 'usd',
    }).amount, amount = _a === void 0 ? 0 : _a;
    return {
        devPlanId: id,
        devPlanName: devPlan.name || '',
        devPlanInterval: devPlan.interval || '',
        devPlanPrice: amount,
        devPlanCurrency: devPlan.currency,
        campaign: campaign,
    };
});
